/**
 * Garmin structured workout palette — mirrors Ai-Tempo GarminWorkoutConstants.ts
 */

export const INTENSITY_DISPLAY_COLOR: Record<string, string> = {
  warmup: '#E89C3A',
  active: '#3A7BD5',
  interval: '#D53A6B',
  rest: '#9E9E9E',
  recovery: '#66BB6A',
  cooldown: '#26A69A',
  other: '#78909C',
  warmUp: '#E89C3A',
  coolDown: '#26A69A',
};

export interface PaletteBlockDef {
  id: string;
  title: string;
  wide?: boolean;
  blocks: unknown[];
}

export const PALETTE_BLOCKS: PaletteBlockDef[] = [
  {
    id: 'warmup',
    title: 'گرم‌کردن',
    blocks: [{
      type: 'step',
      length: { value: 1, unit: 'repetition' },
      steps: [{
        name: 'Warm Up',
        length: { value: 600, unit: 'second' },
        targets: [{ minValue: 40, maxValue: 50 }],
        intensityClass: 'warmup',
        openDuration: false,
      }],
    }],
  },
  {
    id: 'active',
    title: 'فعالیت',
    blocks: [{
      type: 'step',
      length: { value: 1, unit: 'repetition' },
      steps: [{
        name: 'Active',
        length: { value: 900, unit: 'second' },
        targets: [{ minValue: 70, maxValue: 80 }],
        intensityClass: 'active',
        openDuration: false,
      }],
    }],
  },
  {
    id: 'interval',
    title: 'اینتروال',
    blocks: [{
      type: 'repetition',
      length: { value: 5, unit: 'repetition' },
      steps: [
        {
          type: 'step',
          name: 'Hard',
          length: { unit: 'second', value: 180 },
          targets: [{ minValue: 85, maxValue: 100 }],
          intensityClass: 'interval',
          openDuration: false,
        },
        {
          type: 'step',
          name: 'Rest',
          length: { unit: 'second', value: 120 },
          targets: [{ minValue: 40, maxValue: 55 }],
          intensityClass: 'rest',
          openDuration: false,
        },
      ],
    }],
  },
  {
    id: 'recovery',
    title: 'ریکاوری',
    blocks: [{
      type: 'step',
      length: { value: 1, unit: 'repetition' },
      steps: [{
        name: 'Recovery',
        length: { value: 600, unit: 'second' },
        targets: [{ minValue: 40, maxValue: 55 }],
        intensityClass: 'recovery',
        openDuration: false,
      }],
    }],
  },
  {
    id: 'cooldown',
    title: 'سردکردن',
    blocks: [{
      type: 'step',
      length: { value: 1, unit: 'repetition' },
      steps: [{
        name: 'Cool Down',
        length: { value: 600, unit: 'second' },
        targets: [{ minValue: 40, maxValue: 50 }],
        intensityClass: 'cooldown',
        openDuration: false,
      }],
    }],
  },
  {
    id: 'rampup',
    title: 'Ramp Up',
    wide: true,
    blocks: [{
      type: 'repetition',
      length: { value: 1, unit: 'repetition' },
      steps: [
        {
          type: 'step', name: 'Ramp Up 1',
          length: { unit: 'second', value: 300 },
          targets: [{ minValue: 55, maxValue: 65 }],
          intensityClass: 'active', openDuration: false,
        },
        {
          type: 'step', name: 'Ramp Up 2',
          length: { unit: 'second', value: 300 },
          targets: [{ minValue: 65, maxValue: 75 }],
          intensityClass: 'active', openDuration: false,
        },
        {
          type: 'step', name: 'Ramp Up 3',
          length: { unit: 'second', value: 300 },
          targets: [{ minValue: 75, maxValue: 85 }],
          intensityClass: 'active', openDuration: false,
        },
      ],
    }],
  },
  {
    id: 'rampdown',
    title: 'Ramp Down',
    wide: true,
    blocks: [{
      type: 'repetition',
      length: { value: 1, unit: 'repetition' },
      steps: [
        {
          type: 'step', name: 'Ramp Down 1',
          length: { unit: 'second', value: 300 },
          targets: [{ minValue: 75, maxValue: 85 }],
          intensityClass: 'active', openDuration: false,
        },
        {
          type: 'step', name: 'Ramp Down 2',
          length: { unit: 'second', value: 300 },
          targets: [{ minValue: 65, maxValue: 75 }],
          intensityClass: 'active', openDuration: false,
        },
        {
          type: 'step', name: 'Ramp Down 3',
          length: { unit: 'second', value: 300 },
          targets: [{ minValue: 55, maxValue: 65 }],
          intensityClass: 'active', openDuration: false,
        },
      ],
    }],
  },
];
